import { render, staticRenderFns } from "./notes-modal.vue?vue&type=template&id=78ea02d2&"
import script from "./notes-modal.vue?vue&type=script&lang=js&"
export * from "./notes-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports